import { render, staticRenderFns } from "./JLayoutTabs.vue?vue&type=template&id=78748e87&scoped=true&"
import script from "./JLayoutTabs.vue?vue&type=script&lang=js&"
export * from "./JLayoutTabs.vue?vue&type=script&lang=js&"
import style1 from "./JLayoutTabs.vue?vue&type=style&index=1&id=78748e87&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78748e87",
  null
  
)

export default component.exports